import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import withStore from 'with/Store'

import CodeField from 'components/CodeField'
import Modal from 'components/Modal'
import Button from 'components/buttons/Button'

import AuthAPI from 'api/AuthAPI'
import handleFormErrors from 'utils/handleFormErrors'
import { getToken, setToken } from 'utils/auth'

import styles from './index.css'


@withRouter
@withStore()
export default class EnterCode extends React.Component {
  
  static propTypes = {
    dispatch : PropTypes.func.isRequired
  }

  state = {
    code: ''
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    window.localStorage.removeItem('employee')
  }

  async submit() {
    this.setState({ submitting: true })
    const {status, response} = await AuthAPI.employeeLogin(this.state.code)
    this.setState({ submitting: false })

    if (status == 400 || status == 404) {
      return this.props.dispatch({ type: 'SHOW_ERROR', payload: 'Invalid code' })
    }
    if (status !== 200 || !response.token) {
      return this.props.dispatch({ type: 'SHOW_ERROR', payload: 'Something went wrong' })
    }
    
    setToken(response.token)
    window.localStorage.setItem('employee', JSON.stringify(response))

    this.props.history.replace('/tracker')
  }

  render() {
    return (
      <Modal open={true}>
        <h1>Enter ID Code</h1>
        <CodeField 
          value={this.state.code}
          onChange={code => this.setState({ code })}
          onSubmit={this.submit}
          />
        <Button 
          loading={this.state.submitting}
          color='orange' onClick={this.submit}>Submit ID</Button>
      </Modal>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/EnterCode/index.jsx